import { useQuery } from "react-query"
import { getCustomersPendingsStatisticCardsData } from "api/Pendings";


export const useCustomersPendingsStatisticCardsData = () => {
    return useQuery<Array<any> | any>(
      ['customerPending'],
        () => getCustomersPendingsStatisticCardsData(),
        {
            onError(error: any) {
                console.error(error)
            }
        }
    )
}